import React, { useEffect, useState } from "react"
import { Alert } from "reactstrap"
import Paginate from "components/paginate"
import withModal from "components/modal"
import { Spinner } from "components/spinner"
import ProductCard from "./ProductCard"

const ProductListPageCl = ({ total, pagination, setPagination, addToCart, productData, getFetchProductData }) => {
  const inputRefs = []

  /**
   * create option items
   */
  const selectOption = () => {
    const resultTemplate = []
    for (let i = 1; i < 100; i++) {
      resultTemplate.push(
        <option key={i} value={i}>
          {i}
        </option>
      )
    }
    return resultTemplate
  }

  /**
   * Create input refs
   * @param {*} ref
   * @param {*} id
   */
  const setRef = (ref, id) => {
    const refObj = {
      id,
      ref
    }
    inputRefs.push(refObj)
  }

  if (!productData) {
    return <Spinner />
  }

  return (
    <div>
      {total > 0 ? (
        <>
          <div className="row w-100 m-0">
            {productData
              .map(item => {
                return (
                  <ProductCard
                    key={item.id}
                    item={item}
                    setRef={setRef}
                    selectOption={selectOption}
                    onAddToCartClick={() => {
                      addToCart(
                        item.id,
                        Number.parseInt(
                          inputRefs.find(refItem => refItem.id === item.id).ref
                            .value,
                          10
                        )
                      )
                    }}
                  />
                )
              })}
          </div>
          <div
            className="d-flex justify-content-end"
            style={{ paddingLeft: "15px", paddingRight: "15px" }}
          >
            <Paginate
              totalPages={total}
              onPageChange={page => {
                setPagination({
                  ...pagination,
                  currentPage: page.selected
                })
                getFetchProductData(page.selected)
              }}
              forcePage={pagination.currentPage}
            />
          </div>
        </>
      ) :
      (
        <div>
          <Alert color="info">找不到與查詢條件有關商品</Alert>
        </div>
      )}
    </div>
  )
}

export default withModal(ProductListPageCl)
